<template>
  <label
    :class="[
      ns.b(),
      ns.is('disabled', disabled),
      ns.is('focus', focus),
      ns.is('bordered', border),
      ns.is('checked', modelValue === actualValue),
      ns.m(size),
    ]"
  >
    <span
      :class="[
        ns.e('input'),
        ns.is('disabled', disabled),
        ns.is('checked', isGroup ? modelValue === actualValue : isSingle),
      ]"
    >
      <input
        ref="radioRef"
        v-model="modelValue"
        :class="ns.e('original')"
        :value="actualValue"
        :name="name || radioGroup?.name"
        :disabled="disabled"
        :checked="isGroup ? modelValue === actualValue : isSingle"
        type="radio"
        @focus="focus = true"
        @blur="focus = false"
        @change="handleChange"
        @click.stop
      />
      <span :class="ns.e('inner')" />
    </span>
    <span :class="ns.e('label')" @keydown.stop>
      <slot>
        {{ label }}
      </slot>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { nextTick, ref } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { radioEmits, radioProps } from './radio'
import { useRadio } from './use-radio'

defineOptions({
  name: 'LtRadio',
})
const props = defineProps(radioProps)
const emit = defineEmits(radioEmits)

const ns = useNamespace('radio')
const {
  radioRef,
  radioGroup,
  focus,
  size,
  disabled,
  modelValue,
  actualValue,
  isGroup,
} = useRadio(props, emit)
const isSingle = ref(false)

function handleChange() {
  if (!isGroup.value) {
    isSingle.value = !isSingle.value
    emit('change', isSingle.value)
  } else {
    nextTick(() => {
      console.log('handleChange', modelValue.value)
      emit('change', modelValue.value)
    })
  }
}
</script>
